/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReadApiV1NotificationsFeedUserEventReadIdxPatchMutationResponse,
  ReadApiV1NotificationsFeedUserEventReadIdxPatchPathParams,
  ReadApiV1NotificationsFeedUserEventReadIdxPatchQueryParams,
  ReadApiV1NotificationsFeedUserEventReadIdxPatchHeaderParams,
  ReadApiV1NotificationsFeedUserEventReadIdxPatch422,
} from '../../types/ReadApiV1NotificationsFeedUserEventReadIdxPatch.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const readApiV1NotificationsFeedUserEventReadIdxPatchMutationKey = () => [{ url: '/api/v1/notifications_feed_user_event/read/{idx}' }] as const

export type ReadApiV1NotificationsFeedUserEventReadIdxPatchMutationKey = ReturnType<typeof readApiV1NotificationsFeedUserEventReadIdxPatchMutationKey>

/**
 * @summary Read
 * {@link /api/v1/notifications_feed_user_event/read/:idx}
 */
export async function readApiV1NotificationsFeedUserEventReadIdxPatch(
  idx: ReadApiV1NotificationsFeedUserEventReadIdxPatchPathParams['idx'],
  params?: ReadApiV1NotificationsFeedUserEventReadIdxPatchQueryParams,
  headers?: ReadApiV1NotificationsFeedUserEventReadIdxPatchHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ReadApiV1NotificationsFeedUserEventReadIdxPatchMutationResponse,
    ResponseErrorConfig<ReadApiV1NotificationsFeedUserEventReadIdxPatch422>,
    unknown
  >({ method: 'PATCH', url: `/api/v1/notifications_feed_user_event/read/${idx}`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

/**
 * @summary Read
 * {@link /api/v1/notifications_feed_user_event/read/:idx}
 */
export function useReadApiV1NotificationsFeedUserEventReadIdxPatch<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReadApiV1NotificationsFeedUserEventReadIdxPatchMutationResponse,
      ResponseErrorConfig<ReadApiV1NotificationsFeedUserEventReadIdxPatch422>,
      {
        idx: ReadApiV1NotificationsFeedUserEventReadIdxPatchPathParams['idx']
        params?: ReadApiV1NotificationsFeedUserEventReadIdxPatchQueryParams
        headers?: ReadApiV1NotificationsFeedUserEventReadIdxPatchHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? readApiV1NotificationsFeedUserEventReadIdxPatchMutationKey()

  return useMutation<
    ReadApiV1NotificationsFeedUserEventReadIdxPatchMutationResponse,
    ResponseErrorConfig<ReadApiV1NotificationsFeedUserEventReadIdxPatch422>,
    {
      idx: ReadApiV1NotificationsFeedUserEventReadIdxPatchPathParams['idx']
      params?: ReadApiV1NotificationsFeedUserEventReadIdxPatchQueryParams
      headers?: ReadApiV1NotificationsFeedUserEventReadIdxPatchHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ idx, params, headers }) => {
        return readApiV1NotificationsFeedUserEventReadIdxPatch(idx, params, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}